import CompLayout from "@/pcomponents/comp_stu/layout/layout";
import MoveButtonArea from "@/pages/comp/plan/coolen/common/move_btn_area";
import StuUseListArea from "@/pages/comp_stu/textbook/common/stu_use_list";

function CoolenMovePage(){
  return (
    <CompLayout isLeftArea={false} isConTitle={false}>
      <MoveButtonArea></MoveButtonArea>
      <div>
        <StuUseListArea
          show_opt={{
            is_show_back_btn: false
          }}
        ></StuUseListArea>
      </div>
    </CompLayout>
  );
}

export default CoolenMovePage;